import React from "react";
import { Layout, Menu } from "antd";
import {
	UserOutlined,
	TeamOutlined,
	SettingOutlined,
	HistoryOutlined,
	SwapOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const MemberNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const menuItems = [
		{
			key: "/member/view-all-members",
			icon: <TeamOutlined />,
			label: "성도 목록",
		},
		{
			key: "/member/bulk-edit-members",
			icon: <SettingOutlined />,
			label: "성도 정보 일괄 변경",
		},
		{
			key: "/member/view-disciplinary-records",
			icon: <HistoryOutlined />,
			label: "징계 기록 관리",
		},
		{
			key: "/member/view-transfer-records",
			icon: <SwapOutlined />,
			label: "이명 기록 관리",
		},
	];

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	// Get the current selected key based on the current path
	const getSelectedKey = () => {
		const path = location.pathname;
		const menuItem = menuItems.find((item) => item.key === path);
		return menuItem ? menuItem.key : "/member/view-all-members";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<UserOutlined />
				<span>성도 관리</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default MemberNavigation;
